
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Room } from '@/class/room'
import Qr from '@/components/Utils/Qr.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'

@Component({
  components: {
    Qr,
    BtnSquare
  }
})
export default class Gm extends Vue {
  @Prop() roomId!: string;
  room = new Room(this.roomId);
  selectedIndex = 0;

  get roomMembers () {
    return this.room.members
  }

  getPlayerName (id: string) {
    const member = this.room.getRoomMember(id)
    return member ? member.name : ''
  }

  getPlayerURL (id: string): string {
    return `${location.protocol}//${location.host}/room/${this.roomId}/player/${id}/`
  }

  select (index: number) {
    this.selectedIndex = index
  }

  copyToURL (id: string) {
    // 目的の文字列が入っている p要素を取得します。
    const element = document.querySelector(`#url-${id}`)
    if (!element) { return }
    // seletionオブジェクトを取得します。
    const selection = window.getSelection()
    if (!selection) { return }
    // rangeオブジェクトを生成します。
    const range = document.createRange()
    // rangeオブジェクトに p要素を与えます。
    range.selectNodeContents(element)
    // 一旦、selectionオブジェクトの持つ rangeオブジェクトを削除します。
    selection.removeAllRanges()
    // 改めて先程生成した rangeオブジェクトを selectionオブジェクトに追加します。
    selection.addRange(range)
    // クリップボードにコピーします。
    const succeeded = document.execCommand('copy')
    if (succeeded) {
      // コピーに成功した場合の処理です。
      alert('copy')
    } else {
      // コピーに失敗した場合の処理です。
    }
    // selectionオブジェクトの持つrangeオブジェクトを全て削除しておきます。
    selection.removeAllRanges()
  }
}
